import React, { useState } from "react";
import Image from "../elements/Image";
import { Link } from "react-router-dom";

export const SingleBlog = ({ data }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 10;


  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = data.slice(indexOfFirstBlog, indexOfLastBlog);
  const totalPages = Math.ceil(data.length / blogsPerPage);

  return (
    <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4 pb-28">
      {/* Blog grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {currentBlogs.map((blog) => (
          <div
            key={blog.id}
            className="relative flex border px-5 py-6 rounded border-shades-08 bg-shades-07  overflow-hidden"
          > 
            <div className="max-w-[260px] shrink w-full aspect-[16/10] flex items-center justify-center rounded-lg overflow-hidden">
              <Image
                src={blog.image}
                width="100%"
                height="100%"
                alt={blog.title} 
                classes={"w-full h-full object-cover"}
              />
            </div>
 
            <div className="flex flex-col gap-4 shrink-0 text-white px-8 py-8 flex-1">
              <div className="text-xl font-semibold leading-6">{blog.title}</div>
              <div className="text-base text-secondary leading-6">{blog.description}</div> 
              <div className="mt-auto">
                <div className="relative flex items-center ">
                  <Link
                    to={"/blogDetail"}
                    className="text-primary hover:text-shades-06 duration-100 text-base items-center flex gap-2"
                  >
                    Read more
                    <span>
                      <i className="fa-regular fa-arrow-right-long"></i>
                    </span>
                  </Link>
                  <div className="ml-auto text-sm font-normal leading-6 text-secondary">{blog.date}</div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="flex justify-center items-center gap-2 mt-12">
        <div className="flex items-center border border-[#7C7C7C] rounded-md overflow-hidden">
          {Array.from({ length: totalPages }).map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentPage(index + 1)}
              className={`w-10 h-10 flex justify-center items-center border-r transition
          ${currentPage === index + 1
                  ? "bg-shades-06 text-shades-02 font-semibold"
                  : "bg-transparent text-white hover:bg-shades-06 hover:text-shades-02"
                }`}
            >
              {index + 1}
            </button>
          ))}
          {currentPage < totalPages && (
            <button
              onClick={() => setCurrentPage(currentPage + 1)}
              className="px-4 h-10 flex justify-center items-center border-[#7C7C7C] text-white hover:bg-shades-06 hover:text-black transition"
            >
              Next →
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
